import { SearchTerm } from './SearchTerm';

const CategorySearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "trnName",
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    },
];

export default CategorySearch;
